import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import SimpleNav from '../components/Nav/SimpleNav'
export const PrivateRoute = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => (
        <Route
            {...rest}
            component={props => {
                switch (isAuthenticated) {
                    case true:
                        return <> <SimpleNav /> <Component {...props} /></>
                    case false:
                        return <Redirect to="/" />
                    default:
                        return <div>Loading...</div>
                }

            }}
        />
    );


const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.user.isAuthenticated
    };
};

export default connect(mapStateToProps)(PrivateRoute)